import React, { useState } from 'react';
import {
    PageContainer,
    SectionTitle,
    TabMenu,
    Hero,
    TabButton,
    PointsContainer,
    FocalCard,
    FocalImage,
} from './styles';

const offices = [
    {
        region: 'Tshuapa',
        address: 'YAKOBO n° 1, Q. URBAINS/COMMUNE de Boende',
        contact: '(+243) 97 04 09 114',
        role: 'Point focal de la province du Tshuapa',
        image: '/images/codhod-tshuapa.jpeg',
        province: 'Tshuapa',
    },
    {
        region: 'Kwango',
        address: '',
        contact: '(+243) 81 45 64 972',
        role: 'Point focal de la province du Kwango',
        image: '/images/codhod-kwango.jpeg',
        province: 'Kwango',
    },
    {
        region: 'Kikwit',
        address: 'MUPOPO n°5, Q LUNIA PLATEAU, Ville de Kikwit',
        contact: '(+243) 81 03 09 491',
        role: 'Point focal de la province du Kwilu',
        image: '/images/codhod-kwilu.jpeg',
        province: 'Kwilu',
    },
    {
        region: 'Mwene Ditu',
        address: 'CENTRALE n°26, Q Industriel, Ville de Mweneditu',
        contact: '(+243) 85 13 76 822',
        role: 'Point focal de la province du Lomami',
        image: '/images/codhod-lomami.jpeg',
        province: 'Lomami',
    },
    {
        region: 'Kananga',
        address: 'LIKASI n°19, Q MALANDJI, Ville de Kananga',
        contact: '(+243) 82 00 15 609',
        role: 'Point focal de la province du Kasaï Central',
        image: '/images/codhod-kananga.png',
        province: 'Kasaï Central',
    },
    {
        region: 'Tshikapa',
        address: 'National n°1, Commune de DIBUMBA 2, Ville de Tshikapa',
        contact: '(+243) 99 89 89 696',
        role: 'Point focal de la province du Kasaï',
        image: '/images/codhod-tshikapa.png',
        province: 'Kasaï',
    },
    {
        region: 'Inongo',
        address: 'Boulevard LUMUMBA n°4, Commune de PONGONZOLI, Ville d\'Inongo',
        contact: '(+243) 81 40 23 408',
        role: 'Point focal de la province du Mai-Ndombe',
        image: '/images/codhod-mai-ndombe.png',
        province: 'MAI-NDOMBE',
    },
    {
        region: 'Mbuji-Mayi',
        address: 'LUMUMBA ,Q BUBANJI ,Commune de DJULU, Ville de Mbuji-Mayi',
        contact: '(+243) 89 46 81 777',
        role: 'Point focal de la province du Kasaï Oriental',
        image: '/images/codhod-kasai-oriental.png',
        province: 'Kasaï Oriental',
    },
    {
        region: 'Matadi',
        address: 'BUNGIAMA n°5,Q Ville Basse ,Commune de MATADI',
        contact: '(+243) 82 23 03 830',
        role: 'Point focal de la province du Kongo Central',
        image: '/images/codhod-kongo-central.png',
        province: 'Kongo Central',
    },
    {
        region: 'Sankuru',
        address: '',
        contact: '',
        role: 'Point focal de la province du Sankuru',
        image: '/images/codhod-sankuru.jpeg',
        province: 'Sankuru',
    },

    // Ajoute d'autres bureaux si besoin
];

const allProvinces = ['Tous', ...new Set(offices.map(o => o.province))];

const FocalOffices = () => {
    const [selectedProvince, setSelectedProvince] = useState('Tous');

    const filteredOffices =
        selectedProvince === 'Tous'
            ? offices
            : offices.filter(o => o.province === selectedProvince);

    return (
        <>
            <Hero>
                <h1>Nos points focaux</h1>
            </Hero>
            <PageContainer>
                <SectionTitle>Présentation des bureaux</SectionTitle>
                <TabMenu>
                    {allProvinces.map(province => (
                        <TabButton
                            key={province}
                            isActive={selectedProvince === province}
                            onClick={() => setSelectedProvince(province)}
                        >
                            {province}
                        </TabButton>
                    ))}
                </TabMenu>

                <PointsContainer>
                    {filteredOffices.map((office, index) => (
                        <FocalCard key={index}>
                            <FocalImage src={office.image} alt={office.region} />
                            <h3>{office.region}</h3>
                            <p><strong>Adresse :</strong> {office.address}</p>
                            <p><strong>Contact :</strong> {office.contact}</p>
                            <p><strong>Rôle :</strong> {office.role}</p>
                        </FocalCard>
                    ))}
                </PointsContainer>
            </PageContainer>
        </>
    );
};

export default FocalOffices;
